var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCambioManual = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 32 32",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M10.5,15.5 L15.5,15.5 L15.5,11 C15.5,10.7238576 15.7238576,10.5 16,10.5 C16.2761424,10.5 16.5,10.7238576 16.5,11 L16.5,15.5 L21.5,15.5 L21.5,11 C21.5,10.7238576 21.7238576,10.5 22,10.5 C22.2761424,10.5 22.5,10.7238576 22.5,11 L22.5,16 C22.5,16.1380712 22.4440356,16.2630712 22.3535534,16.3535534 C22.2630712,16.4440356 22.1380712,16.5 22,16.5 L16.5,16.5 L16.5,21 C16.5,21.2761424 16.2761424,21.5 16,21.5 C15.7238576,21.5 15.5,21.2761424 15.5,21 L15.5,16.5 L10.5,16.5 L10.5,21 C10.5,21.2761424 10.2761424,21.5 10,21.5 C9.72385763,21.5 9.5,21.2761424 9.5,21 L9.5,11 C9.5,10.7238576 9.72385763,10.5 10,10.5 C10.2761424,10.5 10.5,10.7238576 10.5,11 L10.5,15.5 Z M29.5,16 C29.5,23.4559166 23.4559166,29.5 16,29.5 C8.54408343,29.5 2.5,23.4559166 2.5,16 C2.5,8.54408343 8.54408343,2.5 16,2.5 C23.4559166,2.5 29.5,8.54408343 29.5,16 Z M28.5,16 C28.5,9.09636818 22.9036318,3.5 16,3.5 C9.09636818,3.5 3.5,9.09636818 3.5,16 C3.5,22.9036318 9.09636818,28.5 16,28.5 C22.9036318,28.5 28.5,22.9036318 28.5,16 Z"
  }));
};
export default SvgCambioManual;